import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"
import { TbDotsVertical } from "react-icons/tb"
import { Dropdown, MenuItem } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { haveAuth } from "utils"
import OrderDetailsPrintButton from "./OrderDetailsPrintButton"
// import OrderDetailDeleteButton from "./OrderDetailDeleteButton"
import OrderDetailCancelButton from "./OrderDetailCancelButton"
import OrderDetailsLabelPrintButton from "./OrderDetailsLabelPrintButton"
import OrderSendPaymentLink from "./OrderSendPaymentLink"
import OrderDetailsPrintInvoiceButton from "./OrderDetailsPrintInvoiceButton"
import OrderDetailCompleteButton from "./OrderDetailCompleteButton"
import OrderDetailsThermalPrintButton from "./OrderDetailsThermalPrintButton"
import OrderDetailCancelModal from "./OrderDetailCancelModal"
import classes from "./index.module.scss"

const OrderDetailDropdown = props => {
  const {
    order,
    setOrders,
    paymentDetail
  } = props

  const i18n = useTranslation()[1]

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const isOnline =
    useSelector(state =>
      !state.internetStatus.forceOffline
    )

  const showCancelOrderTab =
    haveAuth(["cancelOrder"]) &&
    (
      order.orderStatus === "paid" ||
      order.orderStatus === "pending" ||
      order.orderStatus === "notConfirmed"
    )

  const showCompleteOrderTab =
    haveAuth(["completeOrder"]) &&
    order.orderStatus === "paid"

  const showSendPaymentLink =
    isOnline &&
    order.isPaymentLink &&
    order.orderStatus === "pending"

  const havePrinterAccess =
    haveAuth(["printerAccess"])

  const showLabelPrinterButton =
    havePrinterAccess

  const showDropDown =
    havePrinterAccess ||
    showCancelOrderTab ||
    showSendPaymentLink

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showDropDown) return null

  return (
    <Fragment>
      <Dropdown
        id="id"
        pullRight={isLtr}
        className={classes["dropdown"]}
      >
        <Dropdown.Toggle
          noCaret
          className={classes["dropdown-button"]}
        >
          <TbDotsVertical
            size={20}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {
            showCompleteOrderTab &&
            <MenuItem className={classes["item"]}>
              <OrderDetailCompleteButton
                order={order}
                setOrders={setOrders}
              />
            </MenuItem >
          }

          {
            havePrinterAccess &&
            <MenuItem className={classes["item"]}>
              <OrderDetailsThermalPrintButton
                order={order}
              />
            </MenuItem >
          }

          {
            havePrinterAccess &&
            <MenuItem className={classes["item"]}>
              <OrderDetailsPrintButton
                order={order}
              />
            </MenuItem >
          }

          {
            havePrinterAccess &&
            <MenuItem className={classes["item"]}>
              <OrderDetailsPrintInvoiceButton
                order={order}
              />
            </MenuItem >
          }

          {
            showLabelPrinterButton &&
            <MenuItem className={classes["item"]}>
              <OrderDetailsLabelPrintButton
                order={order}
              />
            </MenuItem >
          }

          {
            showSendPaymentLink &&
            <MenuItem className={classes["item"]}>
              <OrderSendPaymentLink
                order={order}
                paymentDetail={paymentDetail}
              />
            </MenuItem >
          }

          {
            showCancelOrderTab &&
            <MenuItem className={classes["item"]}>
              <OrderDetailCancelButton
                setShowConfirmationModal={setShowConfirmationModal}
              />
            </MenuItem >
          }
        </Dropdown.Menu>
      </Dropdown>

      <OrderDetailCancelModal
        order={order}
        setOrders={setOrders}
        showConfirmationModal={showConfirmationModal}
        setShowConfirmationModal={setShowConfirmationModal}
      />
    </Fragment>
  )
}

export default OrderDetailDropdown